// generateTripId — pure construction of a manual trip's unique id string.
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (the inline tripId
// expression in `buildTripData`,
// `trip_${now}_${Math.random().toString(36).substr(2, 9)}`) as part of the
// behavior-preserving refactor (issue #240). The two ambient entropy reads the
// source performed inline — the wall-clock (`Date.now()`) and the random seed
// (`Math.random()`) — are injected as parameters (defaulting to the same
// `Date.now()` / `Math.random()` calls) so the function is pure and
// deterministic given its arguments while preserving identical call-site output.
//
// String assembly is reproduced exactly, including
// `random.toString(36).substr(2, 9)`.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Build a unique-ish id for a manually created trip.
 *
 * @param {number} [now=Date.now()] - The wall-clock timestamp component.
 * @param {number} [random=Math.random()] - The random seed in `[0, 1)`.
 * @returns {string} The id `trip_${now}_${randomSuffix}`.
 */
export function generateTripId(now = Date.now(), random = Math.random()) {
  return `trip_${now}_${random.toString(36).substr(2, 9)}`;
}

export default generateTripId;
